const WidgetColorNumber = ({variant = 'primary', infoNum='', infoText='', 
        iconJsx=(<i className="bi bi-brightness-high-fill"></i>)}) => {
    return (
        <div className="col-md-6 col-xl-3">
            <div className={`card social-widget-card bg-${variant}`}>
                <div className="card-body">
                <h3 className="text-white m-0">{infoNum||'-'}</h3>
                <span className="m-t-10">{infoText}</span>{" "}
                {iconJsx}
                </div>
            </div> 
        </div>
    );
};

export default WidgetColorNumber;
